export const statePwa = ({ pwaPromptInstall }) => pwaPromptInstall;